import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { applyTemplateParams } from 'site-modules/shared/components/lead-form/utils/utils';
import { LeadFormMarkdownView } from 'site-modules/shared/components/lead-form/lead-form-markdown-view/lead-form-markdown-view';

export function BaseFormHeader({ config: { text, explainingText, className } = {}, templateParams = [] }) {
  return (
    <div className="base-form-header text-gray-darker mt-1_5">
      {text && (
        <div className={classNames('heading-3 mb-0_75', className)}>{applyTemplateParams(templateParams, text)}</div>
      )}
      {explainingText && (
        <div className="mt-0_5">
          <LeadFormMarkdownView markdown={explainingText} templateParams={templateParams} />
        </div>
      )}
    </div>
  );
}

BaseFormHeader.propTypes = {
  config: PropTypes.shape({
    text: PropTypes.string,
    explainingText: PropTypes.string,
    className: PropTypes.string,
  }),
  templateParams: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
    })
  ), // dynamic object
};
